import { If, createPage } from '@/common/util/templateHelpers';
import { LoaderFill, Flex, Box, Title } from '@/common/components';
import { Meta } from '@/common/components/head';
import { RequestPasswordForm } from '@/common/components/forms';

import style from './index.module.scss';
import FillScreenLayout from '@/layouts/FillScreenLayout';
import { useAuthStore } from '@/stores/auth';

export default createPage('RequestPasswordPage', { style }, function RequestPasswordPage ({ className }) {
  const [ state ] = useAuthStore();

  return (
    <FillScreenLayout>
      <Meta title='Request new password' />

      {
        If(!state.ready, () => (
          <LoaderFill large />
        ))
          .Else(() => (
            <Flex center>
              <Flex className={className} directionColumn centerX centerY>
                <Flex directionColumn className='--textCenter'>
                  <Title>Reset Password</Title>
                  <RequestPasswordForm captcha={true} />
                </Flex>
              </Flex>
            </Flex>
          ))
          .EndIf()
      }
    </FillScreenLayout>
  );
});
